import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { StyledDescriptionBlock, StyledTitle } from './ProductDetailStyles'
import { colors } from '../../styles/colors'
import { FileTypeIcon } from '../../utils/getFileTypeIcon'

const DocumentListContainer = styled.div`
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;
`

const StyledDocumentWrapper = styled.a`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  color: ${colors.gray4};
  border-bottom: 1px solid #e2e8f0;
  transition: background-color 0.2s ease;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: #f8fafc;
  }

  small {
    color: ${colors.gray3};
  }
`

const DocumentsBlock = ({ article, withTitle }) => {
  const { t } = useTranslation()
  const showDocuments = article.detailDocuments && article.detailDocuments.length

  if (!showDocuments) {
      return null
  }

  return (
    <StyledDescriptionBlock>
      {withTitle && (
        <StyledTitle className="h1 mb-3">
          {t('productDetail:associatedDocuments')}
        </StyledTitle>
      )}
      
      <DocumentListContainer>
        {article.detailDocuments.map((document) => (
          <StyledDocumentWrapper 
            key={document.id} 
            href={document.url} 
            download={document.name} 
            target="_blank" 
          >
            <FileTypeIcon fileType={document.type} />
            <div>
              <div className="fw-bold text-dark">{document.name || ''}</div>
              <div>
                <small className="text-uppercase">{document.description || ''}</small>
              </div>
            </div>
          </StyledDocumentWrapper>
        ))}
      </DocumentListContainer>
    </StyledDescriptionBlock>
  )
}

export default DocumentsBlock